import { config } from "../config";
import { fetchWithAuth } from "./auth";
async function request(path, options) {
    const response = await fetchWithAuth(`${config.apiUrl}${path}`, options);
    if (!response.ok) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const details = await response
            .json()
            .catch(() => ({}));
        throw new Error(details.message ?? `Ошибка ${response.status}`);
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const data = await response.json();
    return data;
}
function json(body) {
    return {
        method: "POST",
        body: JSON.stringify(body),
    };
}
export function fetchChats(query) {
    const params = new URLSearchParams();
    params.set("page", String(query.page));
    params.set("count", String(query.count));
    if (query.status !== "all") {
        params.set("status", query.status);
    }
    if (query.search.trim().length > 0) {
        params.set("search", query.search.trim());
    }
    if (query.assignedToMe) {
        params.set("assignedToMe", "true");
    }
    return request(`/support/chats?${params.toString()}`);
}
export function fetchStats() {
    return request("/support/stats");
}
export function fetchChat(chatId) {
    return request(`/support/chats/${chatId}`);
}
export function fetchMessages(chatId, params) {
    const search = new URLSearchParams();
    if (params.before !== undefined) {
        search.set("before", params.before);
    }
    if (params.after !== undefined) {
        search.set("after", params.after);
    }
    search.set("limit", String(params.limit ?? 30));
    return request(`/support/chats/${chatId}/messages?${search.toString()}`);
}
export function sendMessage(chatId, body) {
    return request(`/support/chats/${chatId}/messages`, json(body));
}
export function markRead(chatId) {
    return request(`/support/chats/${chatId}/read`, json({}));
}
export function updateChat(chatId, body) {
    return request(`/support/chats/${chatId}`, {
        method: "PATCH",
        body: JSON.stringify(body),
    });
}
export function uploadAttachment(chatId, file) {
    const form = new FormData();
    form.append("file", file);
    return request(`/support/chats/${chatId}/attachments`, { method: "POST", body: form });
}
